<template>
    <div id="searchbar">
		<div class="container">
			<b-row>
				<b-col><b-form-input class="dark-color" size="lg" v-model="firstname" placeholder="First name" autofocus="autofocus" spellcheck="false" autocorrect="off"></b-form-input></b-col>
				<b-col><b-form-input class="dark-color" size="lg" v-model="lastname" placeholder="Last name" spellcheck="false" autocorrect="off"></b-form-input></b-col>
			</b-row>
			<b-row>
				<b-col><b-form-select class="dark-color" size="lg" v-model="selected" :options="servers"></b-form-select></b-col>
				<b-col><b-button size="lg" block variant="dark" @click="creatUrl">Search</b-button></b-col>
			</b-row>
		</div>
    </div>
</template>

<script>

export default {
    name: "SearchBar",
    data() {
        return {
			url: "",
			default: "https://xivapi.com/character/search?name=",
			firstname: "",
			lastname: "",
			selected: "",
			servers: [
				{ value: '', text: 'Server'},
				{ value: 'Adamantoise', text: 'Adamantoise'},
				{ value: 'Aegis', text: 'Aegis'},
				{ value: 'Alexander', text: 'Alexander'},
				{ value: 'Anima', text: 'Anima'},
				{ value: 'Asura', text: 'Asura'},
				{ value: 'Atomos', text: 'Atomos'},
				{ value: 'Bahamut', text: 'Bahamut'},
				{ value: 'Balmung', text: 'Balmung'},
				{ value: 'Behemoth', text: 'Behemoth'},
				{ value: 'Belias', text: 'Belias'},
				{ value: 'Brynhildr', text: 'Brynhildr'},
				{ value: 'Cactuar', text: 'Cactuar'},
				{ value: 'Carbuncle', text: 'Carbuncle'},
				{ value: 'Cerberus', text: 'Cerberus'},
				{ value: 'Chocobo', text: 'Chocobo'},
				{ value: 'Coeurl', text: 'Coeurl'},
				{ value: 'Diabolos', text: 'Diabolos'},
				{ value: 'Durandal', text: 'Durandal'},
				{ value: 'Excalibur', text: 'Excalibur'},
				{ value: 'Exodus', text: 'Exodus'},
				{ value: 'Faerie', text: 'Faerie'},
				{ value: 'Famfrit', text: 'Famfrit'},
				{ value: 'Fenrir', text: 'Fenrir'},
				{ value: 'Garuda', text: 'Garuda'},
				{ value: 'Gilgamesh', text: 'Gilgamesh'},
				{ value: 'Goblin', text: 'Goblin'},
				{ value: 'Gungnir', text: 'Gungnir'},
				{ value: 'Hades', text: 'Hades'},
				{ value: 'Hyperion', text: 'Hyperion'},
				{ value: 'Ifrit', text: 'Ifrit'},
				{ value: 'Ixion', text: 'Ixion'},
				{ value: 'Jenova', text: 'Jenova'},
				{ value: 'Kujata', text: 'Kujata'},
				{ value: 'Lamia', text: 'Lamia'},
				{ value: 'Leviathan', text: 'Leviathan'},
				{ value: 'Lich', text: 'Lich'},
				{ value: 'Louisoix', text: 'Louisoix'},
				{ value: 'Malboro', text: 'Malboro'},
				{ value: 'Mandragora', text: 'Mandragora'},
				{ value: 'Masamune', text: 'Masamune'},
				{ value: 'Mateus', text: 'Mateus'},
				{ value: 'Midgardsormr', text: 'Midgardsormr'},
				{ value: 'Moogle', text: 'Moogle'},
				{ value: 'Odin', text: 'Odin'},
				{ value: 'Omega', text: 'Omega'},
				{ value: 'Pandaemonium', text: 'Pandaemonium'},
				{ value: 'Phoenix', text: 'Phoenix'},
				{ value: 'Ragnarok', text: 'Ragnarok'},
				{ value: 'Ramuh', text: 'Ramuh'},
				{ value: 'Ridill', text: 'Ridill'},
				{ value: 'Sargatanas', text: 'Sargatanas'},
				{ value: 'Shinryu', text: 'Shinryu'},
				{ value: 'Shiva', text: 'Shiva'},
				{ value: 'Siren', text: 'Siren'},
				{ value: 'Spriggan', text: 'Spriggan'},
				{ value: 'Tiamat', text: 'Tiamat'},
				{ value: 'Titan', text: 'Titan'},
				{ value: 'Tonberry', text: 'Tonberry'},
				{ value: 'Twintania', text: 'Twintania'},
				{ value: 'Typhon', text: 'Typhon'},
				{ value: 'Ultima', text: 'Ultima'},
				{ value: 'Ultros', text: 'Ultros'},
				{ value: 'Unicorn', text: 'Unicorn'},
				{ value: 'Valefor', text: 'Valefor'},
				{ value: 'Yojimbo', text: 'Yojimbo'},
				{ value: 'Zalera', text: 'Zalera'},
				{ value: 'Zeromus', text: 'Zeromus'},
				{ value: 'Zodiark', text: 'Zodiark'}
			],
			result: null
		}
	},
	methods: {
		creatUrl: function () {
			if (!this.firstname && !this.lastname) {
				alert("\n\nA man needs a name");
			}
			else {
				this.url = this.url.concat(this.default, this.firstname, '+', this.lastname);
				if (this.selected) {
					this.url = this.url.concat('&server=', this.selected);
				}
			}
			this.$emit('update-url', this.url);
			this.url = "";
		}
	},
}
</script>

<style scoped>
#searchbar {
    height: 15vh;
}

.container {
    max-height: 100%;
    max-width: 100%;
}

.dark-color {
	color: rgb(181, 175, 166);
    background-color: rgb(24, 26, 27);
    border-color: rgb(60, 65, 68);
}
</style>